import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import { ShoppingCart } from "@phosphor-icons/react";

function SiteNav(props) {
    const navigate = useNavigate()


    const handleLogout = async () => {
        try {
            alert('Logout');
            await signOut()

            props.updateAuthStatus(false)
            navigate('/shop')
        } catch (err) { console.log(err) }
    }
    //console.log(props.isAuthenticated)

    return (
        <header>
            <Navbar bg="dark" expand="lg" variant="dark" >
                <Container>
                    <Navbar.Brand as={Link} to="/">
                        <img
                            alt=""
                            src="/img/logo.png"
                            width="40"
                            height="30"
                            className="d-inline-block align-top" 
                        />{' '}
                        Construire.eu
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        {
                            props.isAuthenticated === true && (
                                <Nav className="ms-md-auto">
                                    <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
                                    <Nav.Link as={Link} to="/launch" >Launch</Nav.Link>
                                    <Nav.Link as={Link} to="/">Discover</Nav.Link>
                                    <Nav.Link as={Link} to="/home" >Your Account</Nav.Link>
                                    <Nav.Link as={Link} to="/cart" >
                                        <ShoppingCart size={32} />
                                    </Nav.Link>
                                </Nav>
                            )
                        }
                        {
                            props.isAuthenticated !== true && (
                                <Nav className="ms-md-auto">
                                    <Nav.Link as={Link} to="/login" >Login</Nav.Link>
                                    <Nav.Link as={Link} to="/shop" >Discover</Nav.Link>
                                    <Nav.Link as={Link} to="/cart" >
                                        <ShoppingCart size={32} />
                                    </Nav.Link>
                                </Nav>
                            )
                        }
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    )
}

export default SiteNav;